import React from "react";
import {TreeNode} from "../../../../types/Post";
import {TreeItem} from "../TreeItem";

interface CategoryTreeProps {
  data: TreeNode[];
  selectedId: string | null;
  onSelect: (n: TreeNode) => void;
  onRename?: (n: TreeNode) => void;
  onMove?: (n: TreeNode) => void;
  onChangeCover?: (n: TreeNode) => void;
  onAdd?: (n: TreeNode) => void;
  onDelete?: (n: TreeNode) => void;
  editMode?: boolean;
  isNodeSelectable?: boolean;
  isLeafSelectable?: boolean;
}

export const CategoryTree = ({
  data,
  selectedId,
  onSelect,
  onRename,
  onMove,
  onChangeCover,
  onAdd,
  onDelete,
  editMode = false,
  isNodeSelectable = true,
  isLeafSelectable = true,
}: CategoryTreeProps) => (
  <div className="space-y-1">
    {data.map((n) => (
      <TreeItem
        key={n.id}
        node={n}
        selectedId={selectedId}
        onSelect={onSelect}
        onRename={onRename}
        onAdd={onAdd}
        onMove={onMove}
        onChangeCover={onChangeCover}
        onDelete={onDelete}
        editMode={editMode}
        isNodeSelectable={isNodeSelectable}
        isLeafSelectable={isLeafSelectable}
      />
    ))}
  </div>
);
